import React from 'react'
import PoweredBy from './PoweredBy';

const PoweredByLogo = ({enablePublicLogo, id}) => {
    return enablePublicLogo ? <PoweredBy id={id} /> : '';
  };

export default PoweredByLogo;